// extracted by mini-css-extract-plugin
module.exports = {"categoryDescription":"_2jGRaS7","description":"f-ccD9p","expanded":"_27c9hey","readMore":"b2Omh8I"};